import { render } from "./ProductCardModal.vue?vue&type=template&id=195a60f6"
import script from "./ProductCardModal.vue?vue&type=script&lang=js"
export * from "./ProductCardModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__